'use client';

import { c as _c } from "react/compiler-runtime";
import { authClient } from '@/frontend/auth/auth-client';
import { Button } from '@/frontend/design-system/actions/Button';
const handleLogout = () => {
  void authClient.signOut({
    fetchOptions: {
      onSuccess: () => {
        window.location.href = '/baza';
      }
    }
  });
};
export function LogoutButtonMobile() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Button onClick={handleLogout} color="destructive">Wyloguj się</Button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}